import { useEffect, useRef, useState } from 'react';

export function useWidth() {
  const [width, setWidth] = useState<number>();
  const elementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const updateWidth = () => {
      if (elementRef.current) {
        setWidth(elementRef.current.getBoundingClientRect().width);
      }
    };

    window.addEventListener('resize', updateWidth);

    // Initial update
    updateWidth();

    return () => {
      window.removeEventListener('resize', updateWidth);
    };
  }, []);

  return {
    elementRef,
    width,
  };
}
